<template>
  <div :class="{ active: !secondaryMarket || !isFundRaising }" class="tab-pane fade show block-common-info" id="common"
       role="tabpanel" aria-labelledby="common-tab">
    <div v-if="project.general?.siteUri" class="bci-site">
      <i class="bi-link-45deg"></i>
      <a :href="project.general?.siteUri" target="_blank">
        {{ siteUrlHost }}
      </a>
    </div>

    <rich-content class="bci-features" :html="project.general?.projectFeatures"/>

    <template v-if="checksList.length">
      <div class="dp-section-title">Результаты проверки</div>
      <info-card>
        <info-row v-for="(check, key) in checksList" :key="key" :label="check.name">
          <div class="bci-check-value">
            <span>{{ check.value }}</span>
            <span class="bci-check-value__links">
              <a v-for="(link, index) in check.links" :key="index" :href="link" target="_blank"
                 class="bci-check-value__link">Смотреть</a>
            </span>
          </div>
        </info-row>
      </info-card>
    </template>

    <template v-if="project.general?.companyFiles?.length">
      <div class="dp-section-title">Вложения</div>
      <div class="bci-attachments">
        <document-card
            v-for="document in project.general.companyFiles"
            :key="document.id"
            :name="document.name"
            :url="document.url"
        />
      </div>
    </template>

    <template v-if="project.general?.companyLinks">
      <div class="dp-section-title">Ссылки</div>
      <rich-content :html="project.general.companyLinks"/>
    </template>
  </div>
</template>

<script>
import DocumentCard from "@/components/common/components/DocumentCard.vue";
import InfoCard from "@/components/common/components/InfoCard.vue";
import InfoRow from "@/components/common/components/InfoRow.vue";
import RichContent from "@/components/common/components/RichContent.vue";

export default {
  name: "DetailedProjectCommonInfo",
  components: {DocumentCard, InfoCard, InfoRow, RichContent},
  props: {
    project: {
      type: Object,
      required: true
    },
    secondaryMarket: {
      type: Boolean,
      required: true
    },
    isFundRaising: {
      type: Boolean,
      required: true
    },
    siteUrlHost: {
      type: String,
      default: ""
    }
  },
  computed: {
    checksList() {
      const checks = [];
      const c = this.project.checks;
      if (!c) {
        return checks;
      }
      const checkTypes = [
        {key: 'checkBankruptcy', label: 'Проверка на банкротство'},
        {key: 'checkCourt', label: 'Суды'},
        {key: 'checkEnforcementProceedings', label: 'Исполнительное производство'},
        {key: 'checkRegister', label: 'Реестр недобросовестных поставщиков'},
        {key: 'checkAuction', label: 'Участие в торгах'}
      ];
      checkTypes.forEach(({key, label}) => {
        if (c[key] || c[key + 'Link']) {
          checks.push({
            name: label,
            value: c[key],
            links: [c[key + 'Link']].filter(Boolean)
          });
        }
      });
      return checks.concat(c.checks || []);
    }
  }
};
</script>

<style lang="scss" scoped>
.block-common-info {
  color: var(--font-dark-color);
}

.bci-site {
  margin-bottom: 0.75rem;
}

.bci-features {
  margin-bottom: 0.5rem;
}

.bci-check-value {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;

  &__links {
    flex-shrink: 0;
  }

  &__link {
    color: var(--primary-green-color);
    white-space: nowrap;

    &:hover {
      color: var(--primary-green-color-hover);
    }
  }
}

.bci-attachments {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-width: 40rem;
}
</style>
